import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { httpOnlySecurityService } from '../../../application/iam';

const RefreshTokenError: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    httpOnlySecurityService.logout();
  }, []);

  const handleLogin = () => {
    window.location.href = '/login';
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100" data-testid="refresh-token-error-page">
      <div className="text-center p-8 bg-white rounded-lg shadow-md max-w-lg" data-testid="refresh-token-error-content">
        <h1 className="text-4xl font-bold text-red-600 mb-4" data-testid="refresh-token-error-title">{t('error.oops')}</h1>
        <p className="text-xl text-gray-700 mb-6" data-testid="refresh-token-error-message">{t('auth.refreshFailed')}</p>
        <Button
          onClick={handleLogin}
          className="px-6 py-3 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          data-testid="refresh-token-error-login-button"
        >
          {t('auth.login')}
        </Button>
      </div>
    </div>
  );
};

export default RefreshTokenError;
